import axios from 'axios';

//const BASE_URL = 'https://server.dexterrtech.com/api/';
//const BASE_URL = 'http://127.0.0.1:8000/api';
//const BASE_URL = 'https://invoice-pro-backend-592924701716.asia-south1.run.app/api/';
const BASE_URL = 'https://api-dashboard.shopzo.app/api';
// const BASE_URL = 'http://localhost:8000/api/';



const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});


//Fetch invoice details by ID
export async function getInvoice(invoice_id) {
  const response = await api.get(`/invoices/${invoice_id}/details/`);
  return response.data;
} 

//Fetch receipt details by ID
export async function getReceipt(receipt_id) {
  const response = await api.get(`/payment-receipt/${receipt_id}/`);
  return response.data;
} 

// Fetch ad banners by shop ID
export async function getAdBanners(shopId) {
  const response = await api.get(`/ads/shop/${shopId}/`);
  return response.data;
}

export async function trackAdEvent(adId, eventType) {
  try {
    const deviceType = /Mobi|Android/i.test(navigator.userAgent) ? "MOBILE" : 
                      /iPad|Tablet/i.test(navigator.userAgent) ? "TABLET" : "DESKTOP";
    
    const response = await api.post(`/ads/track/`, {
      ad_id: adId,
      impression_type: eventType, 
      device_type: deviceType
    });
    return response.data;
  } catch (error) {
    console.error('Error tracking ad:', error);
    return null;
  }
} 

export async function trackAdOnInvoice(adId, invoiceNumber) {
  try {
    const response = await api.post(`/ads/invoice-track/`, {
      ad_id: adId,
      invoice_number: invoiceNumber
    });
    return response.data;
  } catch (error) {
    console.error('Error tracking ad on invoice:', error);
    return null;
  }
}